import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IItemDropdown } from 'src/app/core/interfaces/dropdown.models';
import { CiudadDialogService } from './ciudad-dialog.service';
import {Ciudad, CiudadRequestPaginated} from "./ciudad-dialog.model";
import { MessageConstants } from 'src/app/core/constants/message';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-ciudad-dialog',
  templateUrl: './ciudad-dialog.component.html',
  styleUrls: ['./ciudad-dialog.component.css']
})
export class CiudadDialogComponent implements OnInit {
  isFirstLoad: boolean = true;
  totalRows: number = 0;
  lsCiudad: Ciudad[] = [];
  codigosMessage: any;
  mensajesMessage: any;
  loading: boolean = false;
  idProvincia: number = 0;

  readonly: boolean = false;

  visibleMessage: boolean = false;
  messageDetail: string = "";
  messageTitle: string = "";
  messageIcon: string = "";
  messageColor: string = "";

  constructor(private CiudadDialogService: CiudadDialogService
    , public ref: DynamicDialogRef
    , public config: DynamicDialogConfig
    , private secureStorageService: SecureStorageService
    , private cdr: ChangeDetectorRef
  ){
      this.readonly = config.data.readonly
      this.idProvincia = config.data.dataToDialogArr[0]?.idProvincia;
  }

  ngOnInit(): void {

    if(!this.idProvincia){
      this.ref.destroy();
      return
    }

    this.loading = true;
    const companyId = this.secureStorageService.getData("CompanyId");
    let CiudadReq: CiudadRequestPaginated = {
      Nombre:'',
      Codigo:'',
      IdProvincia: this.idProvincia,
      CompanyId: companyId
    };
    this.getCiudadData(CiudadReq);
  }


  getCiudadData(request: CiudadRequestPaginated){

    [this.codigosMessage, this.mensajesMessage] = MessageConstants;
    this.CiudadDialogService.getPaginated(request)
      .subscribe(
        {
          next: (data) => {
            let dataTmp = data;
            if(dataTmp) {
              this.lsCiudad = dataTmp;
              setTimeout(() => { this.cdr?.detectChanges(); });
            }
          },
          error: (error) => {
            if(error){
              console.log(error);
            }
          },
          complete: () => {
            this.loading = false;
            setTimeout(() => { this.cdr?.detectChanges(); });
          }
        }
      );
  }

  onRowDblClick(event: any, dataSelected: any){

    if(this.readonly)return;
    
    if(dataSelected){
      let _description = ((dataSelected.Nombre) ? dataSelected.Nombre : "" ) ;
      let itemDropdown: IItemDropdown = {
        code: dataSelected.Id,
        description: _description,
        dataSerialize: JSON.stringify(dataSelected)
      }
      this.ref.close(itemDropdown);
    }

  }

}
